import React, { forwardRef } from "react";

interface CheckboxProps {
    label: string; value: string;
    name: string;
    selectedValue: string | string[];
    checkboxClass?: string;
    checkboxTextClass?: string;
    register?: any;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
    label,
    value,
    name,
    selectedValue,
    checkboxClass,
    checkboxTextClass,
    ...register
}, ref) => {
    const isChecked = selectedValue.includes(value);

    return (
        <div className={`${checkboxClass}`}>
            <label
                key={value}
                className="inline-flex items-center gap-x-2.5 cursor-pointer shrink-0  border-gray-200 rounded text-blue-600  disabled:opacity-50 disabled:pointer-events-none"
            >
                <input
                    ref={ref}
                    type="checkbox"
                    name={name}
                    value={value}
                    defaultChecked={isChecked}
                    className="shrink-0 size-4 2xl:size-5 rounded border-gray-300 text-gray-600"
                    {...register}
                />
                <span className={`text-sm font-medium text-gray-700 ${checkboxTextClass}`}>{label}</span>
            </label>
        </div>
    );
});

export default Checkbox;
